<template>
  <div class="archive-wrapper"></div>
</template>

<script>
export default {
  name: 'Archive'
}
</script>

<style lang="scss" scoped>
  .archive-wrapper {
    @include page-wrapper-with-header-and-footer;

    padding-top: 40px;
    box-sizing: border-box;
  }
</style>